module.exports = __webpack_public_path__ + "static/media/add.9c072384.svg";